import React from 'react'

import { Image } from '@peracto/peracto-blocks-tailwind'
import Form from './Form/ImageForm'
import { defaultSettings } from './defaults/settings'

const createPlugin = settings => {
    const mergedSettings = { ...defaultSettings, ...settings }
    const RenderComponent = Image

    return {
        FormComponent: props => <Form {...props} />,
        Component: props => <RenderComponent.Component {...props} {...mergedSettings} />,

        name: 'peracto/content/image',
        version: '1.0.0',
        text: mergedSettings.translations.pluginName,
        description: mergedSettings.translations.pluginDescription,
        IconComponent: mergedSettings.IconComponent,

        createInitialState: () => ({
            text: mergedSettings.defaultText,
            loadingMethod: 'normal',
        }),
    }
}

export default createPlugin
